import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { type Theme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';

import { usePartnersReadIntegration } from '@/api/hooks';
import {
  PARTNER_NAV_ROUTES,
  getActivePartnerNavItem,
  getPartnerNavItems,
} from '@/components/template/utils';
import { useTranslate } from '@/state/i18n';
import { controlTokens, partnerTokens } from '@/theme/themePrimitives';

/** Section tabs under the top bar (P17·b, P15): Eventos, Ofertas, Resultados, Links, Integração (with a key) and Conta. */
const PartnerNav = () => {
  const t = useTranslate('components.template.PartnerNav');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: integration } = usePartnersReadIntegration();
  const items = getPartnerNavItems(Boolean(integration?.enabled));
  const active = getActivePartnerNavItem(pathname);

  return (
    <Tabs
      component="nav"
      aria-label={t('label')}
      value={active && items.includes(active) ? active : false}
      onChange={(_, item: keyof typeof PARTNER_NAV_ROUTES) => navigate(PARTNER_NAV_ROUTES[item])}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={sx.tabs}
    >
      {items.map((item) => (
        <Tab key={item} value={item} label={t(`items.${item}`)} />
      ))}
    </Tabs>
  );
};

export default PartnerNav;

const sx = {
  tabs: (theme: Theme) => ({
    px: { xs: 1, md: 2 },
    bgcolor: partnerTokens.bar,
    borderBottom: `1px solid ${partnerTokens.border}`,
    '& .MuiTab-root': { color: partnerTokens.ink },
    '& .MuiTab-root.Mui-selected': { color: controlTokens.primary },
    ...theme.applyStyles('dark', {
      bgcolor: 'background.paper',
      borderColor: 'divider',
      '& .MuiTab-root': { color: 'text.secondary' },
      '& .MuiTab-root.Mui-selected': { color: 'text.primary' },
    }),
  }),
};
